import React from 'react'
import { Box } from '@mui/material'
import type { TeamInformationSharesLineChartLegendProps } from './types'
import { useTranslation } from '../../../../../../shared/hooks/useIntractionTranslate'
import { TeamIdentifier } from './types'
import { LEGEND_CONFIG, TEAM_1_GRADIENT, TEAM_1_SHADOW, LEGEND_BORDER_COLOR, TEAM_COLORS } from './constants'
import { INTERAX_COLORS } from '../../../../../../constants/colors'

/**
 * Render legend icon with specific styles
 */
const renderLegendIcon = (teamName: string): React.ReactNode => {
  if (teamName === TeamIdentifier.TEAM_1) {
    return (
      <Box
        sx={{
          width: `${LEGEND_CONFIG.iconSize}px`,
          height: `${LEGEND_CONFIG.iconSize}px`,
          borderRadius: `${LEGEND_CONFIG.iconBorderRadius}px`,
          marginRight: '8px',
          flexShrink: 0,
          background: TEAM_1_GRADIENT,
          border: `1px solid ${LEGEND_BORDER_COLOR}`,
          boxShadow: TEAM_1_SHADOW
        }}
      />
    )
  }

  if (teamName === TeamIdentifier.TEAM_2) {
    return (
      <Box
        sx={{
          width: `${LEGEND_CONFIG.iconSize}px`,
          height: `${LEGEND_CONFIG.iconSize}px`,
          borderRadius: `${LEGEND_CONFIG.iconBorderRadius}px`,
          marginRight: '8px',
          flexShrink: 0,
          background: TEAM_COLORS.TEAM_2,
          border: `1px solid ${LEGEND_BORDER_COLOR}`
        }}
      />
    )
  }

  return null
}

/**
 * Custom legend component for Team Information Shares Line Chart
 */
export const TeamInformationSharesLineChartLegend: React.FC<TeamInformationSharesLineChartLegendProps> = ({
  payload
}) => {
  const { t } = useTranslation()

  if (!payload || payload.length === 0) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        gap: `${LEGEND_CONFIG.gap}px`,
        paddingTop: '4px',
        paddingLeft: '32px'
      }}
    >
      {payload.map((entry, index) => {
        const teamName = entry.value
        const translatedTeamName =
          teamName === TeamIdentifier.TEAM_1
            ? t('facilitator.devTools.teamInformationShares.legend.team1')
            : teamName === TeamIdentifier.TEAM_2
              ? t('facilitator.devTools.teamInformationShares.legend.team2')
              : teamName

        return (
          <Box
            key={`legend-${index}`}
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer'
            }}
          >
            {renderLegendIcon(teamName)}
            <Box
              component="span"
              className="text-body-2"
              sx={{
                color: INTERAX_COLORS.white,
                fontWeight: 300,
                lineHeight: 1
              }}
            >
              {translatedTeamName}
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}
